<template>
  <div class="sensorError">
    <div class="sensorStatus">
      <el-button size="small" @click="handleClick(1)">传感器异常规则配置</el-button>
      <el-button size="small" @click="handleClick(3)">阈值管理</el-button>
      <!-- <el-button size="small" @click="test1">测试按钮</el-button> -->
      <el-button style="margin-right: 200px" type="primary"   size="small" >数据刷新时间：{{dataTableUpdataTime}}</el-button>
      <div class="OutBtns">
        <el-button  type="primary" size="small" @click="outExcel" :loading="outExcelLoading" >导出全部</el-button>
        <el-button type="primary" size="small" @click="outExcelNow" :loading="outExcelLoading">导出当前</el-button>
        <el-button type="primary" size="small" @click="outExcelSelected(selectedTableData)" :loading="outExcelLoading" >导出自定义</el-button>
      </div>
      <!-- <el-button size="small" @click="handleClick(2)">旋转阈值管理</el-button>
      <el-button size="small" @click="handleClick(3)">机泵阈值管理</el-button> -->
    </div>
    <div class="search">
      <span class="wordFind">查找：</span>
        <el-input
        class="find"
        v-model="search"
        @selection-change="handleSelectionChange"
        size="mini"
        placeholder="请输入关键字"
        @change='startSearch'
        ></el-input>
          <span class="wordPage">选择每页显示的行数：</span>
        <el-select v-model="pagesize" class="page" size="mini" @change="getSelectedMessageData()">
          <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
          </el-option>
        </el-select>
      </div>
    <div class="sensorTable">
      <el-table
        :data="sensordata"
        @selection-change="handleSelectionChange"
        height="100%">
        <el-table-column type="selection" width="55" />
        <el-table-column
        type="index"
        label="序号"
        :index="setMenuIndex"

        sortable>
        </el-table-column>
        <el-table-column
        prop="group_name"
        label="公司"

        sortable>
        </el-table-column>
        <el-table-column
        prop="company_name"
        label="分公司"

        sortable>
        </el-table-column>
        <el-table-column
        prop="factory_name"
        label="车间"

        sortable>
        </el-table-column>
        <el-table-column
        prop="unit_name"
        label="机组"

        sortable>
        </el-table-column>
        <el-table-column
        prop="equipment_name"
        label="设备名"

        sortable>
        </el-table-column>
        <!-- <el-table-column
        prop="equipmentType"
        label="设备类型"
        width="150px"
        sortable>
        </el-table-column> -->
        <el-table-column
        prop="point_type"
        label="测点名称"

        sortable>
        </el-table-column>
        <el-table-column
        prop="rev"
        label="转速"
        sortable
        >
        </el-table-column>
        <el-table-column
        prop="value"
        label="特征值"
        sortable
        >
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="特征值更新时间"
          sortable
          >
        </el-table-column>
        <el-table-column
          prop="sensorException"
          label="实时状态"
          sortable
          >
        </el-table-column>


        <el-table-column
          label="阈值(悬浮见详情)">
           <template #default="props">
            <!-- <p>State: {{ props.row.remark }}</p> -->
            <el-tooltip
            class="box-item"
            effect="dark"
            :content='props.row.remarkDetail'
            placement="left-start"
          >
            <span>{{props.row.remark}}</span>
          </el-tooltip>
          </template>
        </el-table-column>

      </el-table>
    </div>
      <el-pagination
      layout="prev, pager, next"
      :page-size="pagesize"
      :total="dataNumber"
      @current-change="handleCurrentChange"
      :current-page="currentPage">
    </el-pagination>
    <el-dialog
      v-model="dialogVisible"
      title="传感器异常规则配置"
      width="1680px"
      :close-on-click-modal="false">
      <el-table
        :data="tableData"
        :span-method="objectSpanMethod"
        style="width: 100%"
        :row-class-name="tableRowClassName">
        <el-table-column
          prop="equipType"
          label="设备类型"
          width="100">
        </el-table-column>
        <el-table-column
          prop="point_type"
          label="测点类型(特征值)"
          width="220">
        </el-table-column>
        <el-table-column
          label="异常规则判断(开车)"
          width="660">
          <template #default="scope">
            <!-- <el-radio v-model="radio[scope.$index]" @click="handle(scope.$index, scope.row)"  :label="1">高通</el-radio>
            <el-radio v-model="radio[scope.$index]" :label="`${scope.row.equipType}${scope.row.point_type}2`">低通</el-radio>
            <el-radio v-model="radio[scope.$index]" :label="`${scope.row.equipType}${scope.row.point_type}3`">带通</el-radio> -->
            <el-radio v-model="form[scope.$index].rule1" @click="handle(scope.$index, scope.row)"  :label="1">高通</el-radio>
            <el-radio v-model="form[scope.$index].rule1" :label="2">低通</el-radio>
            <el-radio v-model="form[scope.$index].rule1" :label="3">带通</el-radio>
            <span>高线阈值：</span>
            <el-input v-model="form[scope.$index].high1" :disabled="(form[scope.$index].rule1 == 2)" placeholder=""></el-input>
            <span class="downSpan">低线阈值：</span>
            <el-input v-model="form[scope.$index].low1" :disabled="(form[scope.$index].rule1 == 1)"  placeholder=""></el-input>
            <!-- <el-button @click="handle(scope.$index, scope.row)">aaaa</el-button> -->
          </template>
        </el-table-column>
        <el-table-column
          label="异常规则判断(停车)"
          width="660">
          <template #default='scope'>
            <el-radio v-model="form[scope.$index].rule2" :label="1">高通</el-radio>
            <el-radio v-model="form[scope.$index].rule2" :label="2">低通</el-radio>
            <el-radio v-model="form[scope.$index].rule2" :label="3">带通</el-radio>
            <span>高线阈值：</span>
            <el-input v-model="form[scope.$index].high2" :disabled="(form[scope.$index].rule2 == 2)" placeholder=""></el-input>
            <span class="downSpan">低线阈值：</span>
            <el-input v-model="form[scope.$index].low2" :disabled="(form[scope.$index].rule2 == 1)" placeholder=""></el-input>
          </template>
        </el-table-column>
      </el-table>

      <!-- 新增的输入框区域 -->


      <template #footer>
      <span class="dialog-footer">
        <el-button type="success" @click="sumbit(formRef)">保存</el-button>
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
      </template>
    </el-dialog>

    <el-dialog
        v-model="dialogVisible2"
        :title="`阈值配置`"
        width="40%">
      <el-form
          ref="ruleFormRef"
          :model="pointform"
          :rules="rules"
          label-width="160px"
          class="demo-ruleForm"
      >
        <el-form-item label="电池阈值：" prop="battaryLimit">
          <el-input v-model="pointform.batteryLimit" placeholder="默认为0"></el-input>
        </el-form-item>
        <el-form-item label="特征值不更新次数：" prop="nochangeLimit">
          <el-input v-model="pointform.nochangeLimit" placeholder="默认为0"></el-input>
        </el-form-item>
      </el-form>


      <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取消</el-button>
        <el-button type="success" @click="sumbitpointform(pointform)">确定</el-button
        >
      </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {ref, computed, reactive, onMounted,onBeforeUnmount,watch} from 'vue'
import {useStore} from 'vuex'
import { ElMessage } from 'element-plus'
import axios from 'axios'
import {export_json_to_excel} from "../components/ExportFiles/Export2Excel";

export default {
  name: 'sensorError',
  setup(props, ctx) {
//     interface SpanMethodProps {
//   row: User
//   column: TableColumnCtx<User>
//   rowIndex: number
//   columnIndex: number
// }
    // let form=ref();
    var CancelToken = axios.CancelToken;
    var source = CancelToken.source();
    let outExcelLoading=ref(false);
    let dataTableUpdataTime = ref(new Date().getDate());
    let radio = ref([
      '往复设备加速度振动1',
      '往复设备速度振动1',
    ]);
    let selectedTableData=ref([]);
    let radio1 = ref([
      '往复设备加速度振动1',
      '往复设备速度振动1',
    ]);
    let options = ref([
      {
        value: 8,
        label: 8
      },
      {
        value: 10,
        label: 10
      },
      {
        value: 15,
        label: 15
      },
      {
        value: 25,
        label: 25
      },
      {
        value: 50,
        label: 50
      },
      {
        value: 100,
        label: 100
      }
    ])
    let form = ref([
      {
        val:'往复设备加速度振动',
        equipmentType:'往复设备',
        point_type:'加速度振动',
        rule1:1,
        rule2:2,
        high1:'222',
        low1:'2',
        high2:'333',
        low2:'3'
      },
      {
        val:'往复设备速度振动',
        equipmentType:'往复设备',
        point_type:'速度振动',
        rule1:1,
        rule2:2,
        high1:'222',
        low1:'2',
        high2:'333',
        low2:'3'
      },
      {
        val:'往复设备活塞杆位移',
        equipmentType:'往复设备',
        point_type:'活塞杆位移',
        rule1:1,
        rule2:2,
        high1:'222',
        low1:'2',
        high2:'333',
        low2:'3'
      },
      {
        val:'往复设备温度测点',
        equipmentType:'往复设备',
        point_type:'温度测点',
        rule1:1,
        rule2:2,
        high1:'222',
        low1:'2',
        high2:'333',
        low2:'3'
      },
      {
        val:'往复设备动态压力',
        equipmentType:'往复设备',
        point_type:'动态压力',
        rule1:1,
        rule2:2,
        high1:'222',
        low1:'2',
        high2:'333',
        low2:'3'
      },
      {
        val:'旋转设备离心轴位移',
        equipmentType:'旋转设备',
        point_type:'离心轴位移',
        rule1:1,
        rule2:2,
        high1:'222',
        low1:'2',
        high2:'333',
        low2:'3'
      },
      {
        val:'机泵设备加速度振动',
        equipmentType:'机泵设备',
        point_type:'加速度振动',
        rule1:1,
        rule2:2,
        high1:'222',
        low1:'2',
        high2:'333',
        low2:'3'
      },
      {
        val:'机泵设备速度振动',
        equipmentType:'机泵设备',
        point_type:'速度振动',
        rule1:1,
        rule2:2,
        high1:'222',
        low1:'2',
        high2:'333',
        low2:'3'
      },
      {
        val:'机泵设备温度测点',
        equipmentType:'机泵设备',
        point_type:'温度测点',
        rule1:1,
        rule2:2,
        high1:'222',
        low1:'2',
        high2:'333',
        low2:'3'
      },

    ])
    let pointform = ref({
      batteryLimit : 0,
      nochangeLimit : 0
    })
    let form2=ref({
      sensorConfigs:"",
    })
    let sensordata = ref([{
      group_name: '中国石油',
      company_name: '大庆石化',
      factory_name: '二催化',
      unit_name: '重整',
      equipment_name: 'DZTB',
      pointName: '1级A壳体振动V',
      status: '传感器异常',
      updateTime: '2022-3-24 10-45-50.666',
      errorInfo: '停车 加速度峰值超过阈值'
    }])
    let formRef = ref();
    let currentPage = ref(1);
    let dialogVisible = ref(false);
    let dialogVisible2 = ref(false);
    let equipType = ref('');
    let dataNumber=ref(10);
    let val = ref(1);
    let pagesize=ref(10);
    let tableData = ref([{
        equipType: '往复设备',
        point_type: '加速度振动（峰值）'
      }, {
        equipType: '往复设备',
        point_type: '速度振动（有效值）'
      }, {
        equipType: '往复设备',
        point_type: '活塞杆位移（沉降量/偏摆量）'
      }, {
        equipType: '往复设备',
        point_type: '温度测点'
      }, {
        equipType: '',
        point_type: '动态压力（平均压力）'
      }, {
        equipType: '旋转设备',
        point_type: '离心轴位移（通频）'
      }, {
        equipType: '机泵设备',
        point_type: '加速度振动（加速度峰值）'
      }, {
        equipType: '机泵设备',
        point_type: '速度振动（通频有效值）'
      }, {
        equipType: '机泵设备',
        point_type: '温度测点'
      }])
      let pointOption = ref([{
          value: '加速度振动',
          label: '加速度振动'
        }, {
          value: '速度振动',
          label: '速度振动'
        }, {
          value: '活塞杆位移',
          label: '活塞杆位移'
        }, {
          value: '温度测点',
          label: '温度测点'
        }, {
          value: '动态压力',
          label: '动态压力'
      }])
    let ruleForm = ref({
      point_type: pointOption.value[0].value,
      heightLine: '',
      lowLine: ''
    })
    let store = useStore();
    let treeWidth = computed(() => {
      return store.state.contentWidth;
    })
    let search=ref("");
    let startSearch=()=>{
      console.log("search.value",search.value);
      getSelectedMessageData();
    }
    let formatJson = (filterVal, jsonData) => {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }
    let outExcel=()=>{
      // const loadingInstance = ElLoading.service({ fullscreen: true, text: '获取数据中', background: 'rgba(0, 0, 0, 0.7)' })
      outExcelLoading.value = true
      //获取所有传感器异常列表信息
        axios({
          method:"post",
          url:"/api3/sensormessage/get",
        }).then(res => {

            let list=res.data.data
            // loadingInstance.close()
            outExcelLoading.value = false

            // list = list.map(l => {
            //   l.updateTime = timestampToTime( new Date())
            //   return l
            // })

            console.log("list",list);
            const tHeader = [ '公司', '分公司', '车间', '机组', '设备名', '测点名', '转速','特征值','更新时间','正常范围','详细备注' ];
            const filterVal = [  'group_name', 'company_name', 'factory_name', 'unit_name', 'equipment_name', 'point_type', 'rev','value', 'updateTime','remark', 'remarkDetail'];
            const data =  formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, '传感器异常表-导出时间 :'+timestampToTime(new Date().valueOf()));

        })
      // getAllData().then(list => {
      //   console.log(data)
      //   // loadingInstance.close()
      //   outExcelLoading.value = false

      //   // 数据格式处理
      //   list = list.map(l => {
      //     l.updateTime = timestampToTime(new Date(l.startTime).valueOf())
      //     return l
      //   })

      //   const tHeader = [ '公司', 'W分公司', '车间', '机组', '设备名', '测点名称', '实时状态', '更新时间' ];
      //   const filterVal = [  'group_name', 'company_name', 'factory_name', 'unit_name', 'equipment_name', 'pointName', 'status', 'updateTime' ];
      //   const data =  formatJson(filterVal, list);
      //   export_json_to_excel(tHeader, data, '实时状态表  导出时间 :'+timestampToTime(new Date().valueOf()));

      // });
    }
    let outExcelNow=()=>{
      // const loadingInstance = ElLoading.service({ fullscreen: true, text: '获取数据中', background: 'rgba(0, 0, 0, 0.7)' })
      outExcelLoading.value = true
      //获取所有传感器异常列表信息
        // axios({
        //   method:"post",
        //   url:"/api3/sensormessage/get",
        // }).then(res => {

            // let list=res.data.data
            let list=sensordata.value
            // loadingInstance.close()
            outExcelLoading.value = false

            // list = list.map(l => {
            //   l.updateTime = timestampToTime( new Date())
            //   return l
            // })

            console.log("list",list);
            const tHeader = [ '公司', '分公司', '车间', '机组', '设备名', '测点名', '转速','特征值','更新时间','正常范围','详细备注' ];
            const filterVal = [  'group_name', 'company_name', 'factory_name', 'unit_name', 'equipment_name', 'point_type', 'rev','value', 'updateTime','remark', 'remarkDetail'];
            const data =  formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, '传感器异常表-导出时间 :'+timestampToTime(new Date().valueOf()));

        // })
    }
    let outExcelSelected = (val) => {      ///导出excel
      // const loadingInstance = ElLoading.service({ fullscreen: true, text: '获取数据中', background: 'rgba(0, 0, 0, 0.7)' })

        const tHeader = [ '公司', '分公司', '车间', '机组', '设备名', '测点名', '转速','特征值','更新时间','正常范围','详细备注' ];
        const filterVal =[  'group_name', 'company_name', 'factory_name', 'unit_name', 'equipment_name', 'point_type', 'rev','value', 'updateTime','remark', 'remarkDetail'];
        console.log('val',val);
        const data =  formatJson(filterVal, val);
        export_json_to_excel(tHeader, data, '筛选后传感器异常表  导出时间 :'+timestampToTime(new Date().valueOf()));

      };
    let setMenuIndex =((index) => {     ///计算表格中的序号
      // console.log(value)
      return index+1+pagesize.value*(currentPage.value-1)
    })
    let handleClick = (val) => {
      // console.log(val);
      if (val == 1) {
        equipType.value = '往复';
        pointOption.value = [{
        value: '加速度振动',
        label: '加速度振动'
      }, {
        value: '速度振动',
        label: '速度振动'
      }, {
        value: '活塞杆位移',
        label: '活塞杆位移'
      }, {
        value: '温度测点',
        label: '温度测点'
      }, {
        value: '动态压力',
        label: '动态压力'
      }];
      ruleForm.value.point_type =  pointOption.value[0].value;
        dialogVisible.value = true;
      } else if (val == 2) {
        equipType.value = '旋转';
        pointOption.value = [{
          value: '离心轴位移',
          label: '离心轴位移'
        }];
        ruleForm.value.point_type =  pointOption.value[0].value;
        dialogVisible.value = true;
      } else if(val == 3){
        dialogVisible2.value = true;
      }
      else {
        equipType.value = '机泵';
        pointOption.value = [{
          value: '加速度振动',
          label: '加速度振动'
        }, {
          value: '速度振动',
          label: '速度振动'
        }, {
          value: '温度测点',
          label: '温度测点'
        }];
        ruleForm.value.point_type =  pointOption.value[0].value;
        dialogVisible.value = true;
      }

    }
    let timeControl = setInterval(()=>{   ///定时获取数据
      getSelectedMessageData();
      dataTableUpdataTime.value = timestampToTime( new Date());
    },1000*60)
    let timestampToTime = (timestamp) => {
      let date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()) + '';
      let ms = (timestamp % 1000).toString()
      while (ms.length < 3) {
        ms = '0' + ms
      }
      return Y + M + D + h + m + s ;
    }
    watch(() => store.state.nodeLable, () => {
      console.log('点击了设备树');
      // let items = tmpTableData.value;
      getSelectedMessageData();
      return;
    })



    let handleCurrentChange = ((val) => {       ///更改页码，跳转到对应的第val的页
      currentPage.value = val;
      console.log("currentPage",currentPage);
      getSelectedMessageData();
    })
    //submit
    let sumbit = (() => {
      var flag=0;
      for(var i=0;i<form.value.length;i++)
      {
        let item=form.value[i];
        if(item.rule1==3)
        {
          if(item.high1<item.low1)
          {
            ElMessage({
              showClose: true,
              message: '带通条件下，高线阈值不能低于低线阈值',
              type: 'warning',
            })
            flag=1;
            break;
          }
        }
        if(item.rule2==3)
        {
          if(item.high2<item.low2)
          {
            ElMessage({
              showClose: true,
              message: '带通条件下，高线阈值不能低于低线阈值',
              type: 'warning',
            })
            flag=1;
            break;
          }
        }
      }
      if(flag==0)
      {
        //请求后端
        axios({
          method:"post",
          url:"/api3/sensorconfig/set",
          data:form.value
        }).then(res => {
          ElMessage({
          message: '保存成功.',
          type: 'success',
          })
        })
      }


    })

    let sumbitpointform=(()=>{
      const { batteryLimit, nochangeLimit } = pointform.value;

      // 验证batteryLimit和nochangeLimit是否为数字且为正数
      if (isNaN(batteryLimit) || batteryLimit < 0) {
        ElMessage({
          showClose: true,
          message: 'batteryLimit 必须是一个大于等于0的数字',
          type: 'warning',
        })
        return;
      }

      if (isNaN(nochangeLimit) || nochangeLimit < 0) {
        ElMessage({
          showClose: true,
          message: 'nochangeLimit 必须是一个大于等于0的数字',
          type: 'warning',
        })
        return;
      }

      // 提交操作
      //请求后端
      axios({
        method:"post",
        url:"/api3/pointconfig/set",
        data:pointform.value
      }).then(res => {
        ElMessage({
          message: '保存成功.',
          type: 'success',
        })
      })
    })
    //get数据
    let getConfigData=(()=>{
      //获取配置信息
      axios({
        method:"post",
        url:"/api3/sensorconfig/get",
      }).then(res => {
        for(var i=0;i<9;i++)
        {
          form.value[i].rule1=res.data.data[i].rule1
          form.value[i].rule2=res.data.data[i].rule2
          form.value[i].high1=res.data.data[i].high1
          form.value[i].high2=res.data.data[i].high2
          form.value[i].low1=res.data.data[i].low1
          form.value[i].low2=res.data.data[i].low2
        }
      })
      //获取测点配置
      axios({
        method:"post",
        url:"/api3/pointconfig/get"
      }).then(res =>{
        console.log(res.data.batteryLimit)
        pointform.value = {
          batteryLimit : res.data.data.batteryLimit,
          nochangeLimit : res.data.data.noChangeLimit
        }
      })


    })
    let getMessageData=(()=>{
        //获取所有传感器异常列表信息
        axios({
          method:"post",
          url:"/api3/sensormessage/get",
        }).then(res => {
          sensordata.value=res.data.data
          console.log("sensordata",sensordata);
        })
    })
    let getSelectedMessageData=(()=>{
        //获取过滤后的传感器异常列表信息
        let info = store.state.nodeData;
        let url="/api3/sensormessage/getpage";
        for(let i=0;i<5;i++){
          url += '/'+info.node[i]
        }
        // let target="empty";
        let searchVal="empty";
        // if(info.label)
        // {
        //     target=info.label;
        // }
        if(search.value)
        {
          searchVal=search.value
        }
        axios({
          method:"post",
          // url:"/api3/sensormessage/getpage/"+target+"/"+searchVal+'/'+currentPage.value+"/"+pagesize.value,
          url:url+'/'+searchVal+'/'+currentPage.value+"/"+pagesize.value,
        }
        ,{
          cancelToken: source.token
        })
        .then(res => {
          dataTableUpdataTime.value = timestampToTime( new Date());
          sensordata.value=res.data.data
          //处理sensordata数据便于显示
          for(var i=0;i<sensordata.value.length;i++)
          {
            //处理转速单位
            sensordata.value[i].rev=sensordata.value[i].rev+" r/min"
            //处理特征值单位
            sensordata.value[i].value=sensordata.value[i].value+" "+sensordata.value[i].unit
            //处理实时状态
            sensordata.value[i].sensorException="传感器异常"
          }
        })
        let url2="/api3/sensormessage/getnumber";
        for(let i=0;i<5;i++){
          url2 += '/'+info.node[i]
        }
        //获取数据总数
        axios({
          method:"post",
          url:url2+"/"+searchVal,
        }).then(res => {
          dataNumber.value=res.data.data;
        })
    })
    let test1=(()=>{
        console.log("测试按钮");
        // let info = store.state.nodeData;
        // console.log(info.label);
        getSelectedMessageData()

    })
    let objectSpanMethod = ({row, column, rowIndex, columnIndex}) => {
      // console.log(rowIndex, columnIndex);
      if (columnIndex === 0) {
        if (rowIndex  == 0) {
          return {
            rowspan: 4,
            colspan: 1,
          }
        } else if (rowIndex == 5 || rowIndex == 4) {
          return {
            rowspan: 1,
            colspan: 1,
          }
        } else if (rowIndex == 6) {
          return {
            rowspan: 3,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    }
    let handleSelectionChange =(val) =>{
      console.log('handleSelectionChange',val);
      selectedTableData.value=val;
    }
    let tableRowClassName = ({row, rowIndex}) => {
      if ( rowIndex >= 0 && rowIndex < 4 || rowIndex >= 6 && rowIndex <= 8) {
        return 'noneBorder';
      }
    };
    let handle = (val, val1) => {
      console.log(radio);
    }

    onMounted(()=>{
      getConfigData();
      getSelectedMessageData()
    })
    onBeforeUnmount(()=>{
      window.clearInterval(timeControl)
      source.cancel('取消上一次的传感器异常请求.')
    })
    return {
      tableData,
      treeWidth,
      val,
      formRef,
      radio,
      radio1,
      sensordata,
      currentPage,
      equipType,
      dialogVisible,
      dialogVisible2,
      ruleForm,
      pointform,
      pointOption,
      form,
      form2,
      dataNumber,
      pagesize,
      options,
      dataTableUpdataTime,
      outExcelLoading,
      search,
      selectedTableData,
      outExcelSelected,
      handleSelectionChange,
      formatJson,
      outExcel,
      timestampToTime,
      setMenuIndex,
      handleCurrentChange,
      handleClick,
      test1,
      sumbit,
      sumbitpointform,
      getSelectedMessageData,
      getMessageData,
      getConfigData,
      objectSpanMethod,
      tableRowClassName,
      handle,
      startSearch,
      outExcelNow
    }
  },

  computed: {
    ra() {
      console.log(typeof this.radio);
      return this.radio;
    }
  },
  watch: {
    ra(val) {
      console.log(val, this.ra);
    }
  }


}
</script>

<style lang="scss">
  .sensorError{
    width: calc(100% - v-bind(treeWidth));
    height: calc(100vh - 70px);
    background-color: #303749;
    margin-right: 10px;
    margin-bottom: 10px;
    .search{
      display: flex;
      margin: 0px 10px;
      position: relative;
      align-items: center;
      width: 95%;
      float: left;
      span{
        margin-top: 10px;
        font-size: 13px;
        color: #fff;
        float: right;
      }
      span.wordFind{
        margin-left: 5px;
      }
      .el-input{
        // margin-left: 10px;
        margin-top: 10px;
        width: 200px;
        .el-input__inner{
          background-color: #303749;
          color: #fff;
          border: 1px #fff solid;
        }
      }
      .el-input .el-input__inner.active{
        border: 1px red solid;
      }
      .el-select .el-input{
        width: 100px;
        .el-input__inner{
          text-align: center;
          border: 1px #fff solid;
        }
        .el-input__suffix, .el-input__suffix-inner{
          margin-top: 0px;
        }
      }
      span.wordPage{
        position: absolute;
        right: 100px;
        bottom: 0;
      }
      .el-select.page{
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
    .sensorStatus{
      height: 10%;
      background-color: #2c3242;
      margin: 10px 10px 10px 10px;
      position: relative;
      display: flex;
      align-items: center;
      .OutBtns{
        position:absolute;
        right: 30px;
      }
      .el-button:hover{
        border-color: #359186;
        color: #359186;
      }
      .el-button{
        background-color: #2C3242;
        border-color: #fff;
        color: #fff;
        // position:absolute;
        // right: 30px;
        // margin-left: 10px;
        border-radius: 0.5em;
      }
      span.wordpage{
        color: white;
        margin-left: 100px;
      }
    }
    .sensorTable{
      background-color: #2c3242;
      height: 75%;
      margin-left: 10px;
      margin-right: 10px;
      //去除表格最下面那条线
      .el-table::before{
        height: 0px;
      }
      .el-table{
        background-color: #2c3242;
        //去除表头下面那条线
        th.el-table__cell.is-leaf{
          border-bottom: 0px;
        }
        .cell{
          text-align: center;
        }
        th{
          background-color: #2c3242;
          color: #fff;
          // border-right: 1px solid rgba(256, 256, 256, 0.5);
        }
        tr{
          background-color: #2c3242;
          color: #fff;
          td{
            border-bottom: 0px;
          }
        }
        tr:hover td{
          background-color: rgba(107, 199, 255, 0.98) !important;
        }
      }
    }

    .el-pagination{
      margin-top: 50px;
      display: flex;
      ul li{
        background-color: #303749;
        color: #fff;
      }
      ul li:hover{
        color: #359186;
      }
      ul li.active{
        color: #359186;
      }
      .btn-prev{
        background-color: #303749;
        .el-icon{
          color: #fff;
        }
        .el-icon:hover{
          color: #359186;
        }
      }
      .btn-next{
        background-color: #303749;
        .el-icon{
          color: #fff;
        }
        .el-icon:hover{
          color: #359186;
        }
      }
    }
    .el-dialog {
      margin-top: 5%;
    }
    .el-dialog__header{
      background: #2c3242;
      .el-dialog__title {
        color: white;
      }
    }
    .el-dialog__body{
      background: #2c3242;
      .el-table {
        .cell {
          text-align: center;
        }
        th, td{
          background-color: #2C3242;
          color: #fff
        }
        th {
          border-top: 1px solid #fff;
        }
        .noneBorder td{
          border-bottom: 0px;
        }
        tr:hover td {
          background-color: #2C3242 !important;
        }
        .el-radio__label {
          color: #fff;
        }
        .el-radio__input.is-checked .el-radio__inner{
          background-color: #359186;
        }
        .el-input {
          width: 100px;
          .el-input__inner {
            background-color: #2C3242;
            border-color: #fff;
            color: #fff;
            text-align: center;
          }
          .el-input__inner:hover, .el-input__inner:focus {
            border-color: #359186;
            color: #359186;
          }

        }
        .el-input.is-disabled .el-input__inner{
          color: #747575;
        }
        .downSpan {
          margin-left: 30px;
        }
      }
    }
    .el-dialog__footer{
      background: #2c3242;
      color: white;
      .el-button{
        background-color: #2C3242;
        color: #fff;
        border-color: #fff;
      }
      .el-button:hover{
        color: #359186;
        border-color: #359186;
      }
    }
  }
</style>
